export const getHashesByKeyMap = (avatar) => {
    const hashesByKey = new Map();
    Object.entries(avatar.avatar.snapshots).forEach(([key, value]) => {
        hashesByKey.set(`${key}.png`, value);
    });
    return hashesByKey;
};
//# sourceMappingURL=utils.js.map